
  export default {
    props: {
      tooltip: { type: String, default: null },
      image: { type: Object, default: () => {} },
      text: { type: String, default: '' },
      className: { type: String, default: '' },
      doNotLazyLoad: { type: Boolean, default: false },
      width: { type: String, default: null },
      height: { type: String, default: null }
    },
    computed: {
      loadingType () {
        return this.doNotLazyLoad ? 'auto' : 'lazy';
      },
      tooltipOptions () {
        if (!this.tooltip) {
          return null;
        }
        const opts = { content: this.tooltip };
        if (!this.$store.getters['utils/isTablet']) {
          opts.trigger = 'click';
        }
        return opts;
      }
    }
  };
